const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

const PAGE_TYPES = ANALYTICS_EVENTS.PAYLOADS.pageDesigner.pageType;

/* -------------------------------------------------------------------------- *\
 * HOME EVENTS                                                                *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerComponentImpressionViewed,
    ({ name = '', pageType, position, type }) => {
      const eventName = PAGE_TYPES[pageType];
      if (!eventName) return;
      gaInfo.pageType = pageType;
      pushEvent(
        createCustomEventGA4(eventName, [
          ['type', 'impression'],
          ['module_name', name],
          ['position', position],
          ['module_type', type],
        ])
      );
    }
  );

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerComponentClicked,
    ({
      additionalParam,
      clickedDescendantPosition = undefined,
      name = '',
      pageType,
      position,
      type,
    }) => {
      const eventName = PAGE_TYPES[pageType];
      if (!eventName) return;
      const eventDataArray = [
        ['type', 'click'],
        ['module_name', name],
        ['position', position],
        ['module_type', type],
      ];
      eventDataArray.push(
        additionalParam || ['internal_position', clickedDescendantPosition]
      );
      pushEvent(createCustomEventGA4(eventName, eventDataArray));
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
